import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × INGRES: Linear precision and formal perfection
// Delicate outlines, mathematical poses, harmonic detail
export function VasarelyIngresMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Precise linear field */}
      <g transform="translate(397 540)">
        {/* Vertical harmonic lines */}
        {Array.from({ length: 40 }).map((_, i) => {
          const x = -300 + i * 15;
          const wave = Math.sin(i * 0.2) * 20;
          return (
            <line
              key={`v-${i}`}
              x1={x}
              y1={-280 + wave}
              x2={x}
              y2={280 - wave}
              stroke={i % 3 === 0 ? brand.violet : brand.aqua}
              strokeWidth="0.8"
              opacity={0.4}
            />
          );
        })}

        {/* Horizontal harmonic lines */}
        {Array.from({ length: 30 }).map((_, i) => {
          const y = -240 + i * 16;
          const wave = Math.sin(i * 0.25) * 25;
          return (
            <line
              key={`h-${i}`}
              x1={-300 + wave}
              y1={y}
              x2={300 - wave}
              y2={y}
              stroke={i % 3 === 0 ? brand.amber : brand.aqua}
              strokeWidth="0.8"
              opacity={0.35}
            />
          );
        })}

        {/* Elegant elliptical curves */}
        {Array.from({ length: 10 }).map((_, i) => {
          const rx = 50 + i * 25;
          const ry = 80 + i * 20;
          return (
            <ellipse
              key={i}
              cx="0"
              cy="0"
              rx={rx}
              ry={ry}
              fill="none"
              stroke={i % 2 === 0 ? brand.violet : brand.amber}
              strokeWidth="1.5"
              opacity={0.5 - i * 0.03}
            />
          );
        })}

        {/* Mathematical precision nodes */}
        {Array.from({ length: 8 }).map((_, i) =>
          Array.from({ length: 12 }).map((_, j) => {
            const x = -210 + i * 60;
            const y = -200 + j * 40;
            const dist = Math.sqrt(x * x + y * y);
            if (dist > 280) return null;
            return (
              <circle
                key={`${i}-${j}`}
                cx={x}
                cy={y}
                r="2.5"
                fill={brand.white}
                opacity={0.6}
              />
            );
          })
        )}

        {/* Delicate contour path (portrait outline suggestion) */}
        <path
          d={`
            M 0 -180
            Q 60 -160, 80 -100
            Q 90 -40, 85 20
            Q 80 80, 60 130
            Q 40 160, 0 180
            Q -40 160, -60 130
            Q -80 80, -85 20
            Q -90 -40, -80 -100
            Q -60 -160, 0 -180
          `}
          fill="none"
          stroke={brand.violet}
          strokeWidth="2"
          opacity="0.6"
        />

        {/* Inner elegant curve */}
        <path
          d={`
            M 0 -120
            Q 40 -110, 50 -70
            Q 55 -30, 52 10
            Q 50 50, 38 85
            Q 25 110, 0 120
            Q -25 110, -38 85
            Q -50 50, -52 10
            Q -55 -30, -50 -70
            Q -40 -110, 0 -120
          `}
          fill="none"
          stroke={brand.aqua}
          strokeWidth="1.5"
          opacity="0.5"
        />

        {/* Perfect symmetry line */}
        <line x1="0" y1="-280" x2="0" y2="280" stroke={brand.amber} strokeWidth="1" opacity="0.4" strokeDasharray="6 3" />

        {/* Formal precision markers */}
        {[-150, -75, 0, 75, 150].map((x) => (
          <circle key={x} cx={x} cy="0" r="5" fill={brand.amber} opacity="0.5" />
        ))}
      </g>

      {/* Precision note */}
      <text x="397" y="95" textAnchor="middle" fontFamily="serif" fontSize="12" fill={brand.white} opacity="0.5">
        précision mathématique
      </text>
    </g>
  );
}
